module.exports = __webpack_public_path__ + "img/2-1.c8877dc1.svg";